import { useEffect, useState } from "react";
import "../Common/css/styles.css";
import "../Common/css/user.css";
import { createAdmin, deleteAdmin, getAdminDetails, resetAdminPassword, resetStudentPassword, updateAdmin } from "src/Services/user_api";
import { AppBar, Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, InputLabel, List, ListItemButton, ListItemText, Menu, MenuItem, Radio, RadioGroup, Select, Slide, TextField, Toolbar, Typography } from "@mui/material";
import { Close, CloseOutlined, MoreVert } from "@mui/icons-material";
import { CloseCircleFilled, PlusOutlined } from "@ant-design/icons";
import TableToolbar from "src/Components/TableToolbar";
import CustomAlert from "src/Components/Alerts";
import Spinner from "src/Components/Spinner";
import Dialogbox from "src/Components/Dialogbox";
import { de, id, is } from "date-fns/locale";
import { banUnbanStudent, createPaymentPlan, deleteStudent, extendDueDate, getPaymentPlanByUserId, getStudents, pay, updateStudent } from "src/Services/admin_api";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { register } from "src/Services/auth_api";
import { StudentDetails } from "src/Interfaces/auth";
import { set } from "date-fns";
import React from "react";
import { TransitionProps } from "@mui/material/transitions";
import { getSubjectId } from "src/Services/attendance_api";
// import { deleteStudent, getAllStudents } from "src/Services/instructor_api";
// import { createStudent, updateStudent } from "src/Services/admin_api";

const ITEMS_PER_PAGE = 5;

interface ChildItem {
    id: string;
    value: string;
}

interface CategoryItem {
    [category: string]: ChildItem[];
}

export default function StudentMaintenance() {
    const token = sessionStorage.getItem("token") || "";
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertDescription, setAlertDescription] = useState("");
    const [alertType, setAlertType] = useState<"success" | "error" | "warning">("success");
    const [students, setStudents] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);
    const [userSubjects, setUserSubjects] = useState<any[]>([]);
    const [filteredStudents, setFilteredStudents] = useState<any[]>([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedStudent, setSelectedStudent] = useState<any>();
    const [openModal, setOpenModal] = useState(false);
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [parentContactNumber, setParentContactNumber] = useState("");
    const [nic, setNic] = useState("");
    const [dob, setDob] = useState<any | null>(null);
    const [gender, setGender] = useState("");
    const [instructorType, setAdminType] = useState(1);
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [isViewMode, setIsViewMode] = useState(false);
    const [selectedProgramme, setSelectedProgramme] = useState("default");
    const [selectedStream, setSelectedStream] = useState("default");
    const [selectedFreeCourses, setSelectedFreeCourses] = useState<string[]>([]);
    const [scholarshipCode, setScholarshipCode] = useState("");
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [flag, setFlag] = useState(false);
    const [paymentModalOpen, setPaymentModalOpen] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState<string>("");
    const [installmentsCount, setInstallmentsCount] = useState<string>("");
    const [installmentDates, setInstallmentDates] = useState<Dayjs[]>([]);
    const [installmentAmounts, setInstallmentAmounts] = useState<string[]>([]);
    const [subjectId, setSubjectId] = useState<string>("");

    const data: CategoryItem[] = [
        {
            "Fast track A/L": [
                { id: "1", value: "Arts Stream" },
                { id: "2", value: "Commerce Stream" },
                { id: "3", value: "Technology Stream" },
                { id: "4", value: "General English in A/L" }
            ]
        },
        {
            "Diploma": [
                { id: "5", value: "Diploma in Marketing" },
                { id: "6", value: "Diploma in HRM" },
                { id: "7", value: "Diploma in English" },
                { id: "8", value: "Diploma in ICT" }
            ]
        },
        {
            "Certificate course": [
                { id: "9", value: "Certificate course in Marketing" },
                { id: "10", value: "Certificate course in HRM" },
                { id: "11", value: "Certificate course in English" },
                { id: "12", value: "Certificate course in ICT" }
            ]
        }
    ];

    const handleGetSubjectId = async () => {
        try {
            const details = JSON.parse(selectedStudent?.userSubjects?.[0]?.subjectDetails || '{}');
            const programmeName = details?.Programme;
            const streamName = details?.Stream;

            if (!programmeName || !streamName) {
                setSubjectId("");
                return "";
            }

            // `data` is an array where each item is an object with programme name as key
            // and value an array of { id, value } items (value === stream name).
            let matchedId = "";
            for (const entry of data) {
                const key = Object.keys(entry)[0];
                if (key === programmeName) {
                    const list = entry[key] as ChildItem[];
                    const match = list.find(i => i.value === streamName);
                    if (match) {
                        matchedId = match.id;
                        break;
                    }
                }
            }

            // fallback: try programmes array (no ids there) — keep matchedId if found
            if (!matchedId) {
                // optional: attempt to match by programme/stream names in `programmes` for debugging
                const prog = programmes.find(p => p.programme === programmeName);
                const streamExists = prog?.streams?.some(s => s.stream === streamName);
                if (streamExists) {
                    console.warn("Stream matched in programmes but no id present in `data`");
                }
            }

            setSubjectId(matchedId);
            return matchedId;
        } catch (err) {
            console.error("handleGetSubjectId error:", err);
            setSubjectId("");
            return "";
        }
    }

    const handleCreatePaymentPlan = async () => {
        if (isLoading) return;
        setIsLoading(true)
        const body = {
            userId: selectedStudent.id,
            facultyCombinationId: parseInt(subjectId),
            amount: parseFloat(paymentAmount),
            duration: parseInt(installmentsCount),
            installments: parseInt(installmentsCount),
            firstPaymentDate: installmentDates[0]?.toISOString(),
            createdBy: parseInt(sessionStorage.getItem("adminId") || "")
        }

        //console.log(body);

        try {
            await createPaymentPlan(token, body)
            showAlert("Payment plan created.", "success")
            handleGetPaymentPlan()
            setBtnVisible(false)
        } catch (error) {
            showAlert("Failed to create payment plan.", "error")
        } finally {
            setIsLoading(false)
        }
    }

    const [pPlan, setpPlan] = useState<any>()
    const [btnVisible, setBtnVisible] = useState(false)
    const [isPaymentExpired, setIsPaymentExpired] = useState(false)
    const [unlockModalOpen, setUnlockModalOpen] = useState(false)
    const [extensionWeeks, setExtensionWeeks] = useState<string>("")

    const handleGetPaymentPlan = async () => {
        try {
            const res = await getPaymentPlanByUserId(token, selectedStudent.id)
            setpPlan(res)
            setPaymentAmount(res.amount.toString())
            setInstallmentsCount(res.duration.toString())
            setBtnVisible(false)

            // Check if payment is expired
            if (res?.paymentExpirationDate) {
                const expirationDate = dayjs(res.paymentExpirationDate);
                const today = dayjs();
                setIsPaymentExpired(today.isAfter(expirationDate));
            }

            // ensure installmentDates/installmentAmounts are initialized so last installment can be edited
            const duration = parseInt(res.duration || "0", 10) || 0;
            if (duration > 0) {
                const dates = Array.from({ length: duration }, (_, i) => dayjs().add(i * 30, 'day'));
                setInstallmentDates(dates);

                const amounts = Array(duration).fill('');
                // if server gave a dueAmount, use it as the default value for the last installment but keep it editable
                if (res?.dueAmount != null) {
                    const due = Number(res.dueAmount);
                    if (!Number.isNaN(due)) amounts[duration - 1] = due.toFixed(2);
                }
                setInstallmentAmounts(amounts);
            }
        } catch (error) {
            setPaymentAmount("")
            setInstallmentsCount("")
            setBtnVisible(true)
            setIsPaymentExpired(false)
        }
    }

    const handleTemporaryUnlock = () => {
        setExtensionWeeks("")
        setUnlockModalOpen(true)
    }

    const handleConfirmUnlock = async () => {
        try {
            if (!extensionWeeks || parseInt(extensionWeeks) <= 0) {
                showAlert("Please enter a valid number of weeks.", "warning")
                return
            }

            setIsLoading(true)
            const weeksToAdd = parseInt(extensionWeeks);

            // Call handleExtendDueDate to extend the due date
            await handleExtendDueDate()

            setUnlockModalOpen(false)
            setExtensionWeeks("")
        } catch (error) {
            showAlert("Failed to unlock access.", "error")
        } finally {
            setIsLoading(false)
        }
    }

    // Prevent payment modal from reopening after a forced reload
    useEffect(() => {
        const wasClosed = sessionStorage.getItem('paymentModalClosed');
        if (wasClosed === 'true') {
            sessionStorage.removeItem('paymentModalClosed');
            setPaymentModalOpen(false);
            setAnchorEl(null);
        }
    }, []);

    const Transition = React.forwardRef(function Transition(
        props: TransitionProps & {
            children: React.ReactElement<unknown>;
        },
        ref: React.Ref<unknown>,
    ) {
        return <Slide direction="up" ref={ref} {...props} />;
    });
    const programmes = [
        {
            programme: "Fast track A/L", streams: [
                { stream: "Arts Stream", subjects: ["Econ", "Media", "ICT", "Sinhala", "Political Science"] },
                { stream: "Commerce Stream", subjects: ["Business Studies", "Accounts", "Econ", "ICT"] },
                { stream: "Technology Stream", subjects: ["Engineering Technology", "Science For Technology", "ICT"] },
                { stream: "General English in A/L", subjects: [] }
            ]
        },
        {
            programme: "Diploma", streams: [
                { stream: "Diploma in Marketing", subjects: [] },
                { stream: "Diploma in HRM", subjects: [] },
                { stream: "Diploma in English", subjects: [] },
                { stream: "Diploma in ICT", subjects: [] }
            ]
        },
        {
            programme: "Certificate course", streams: [
                { stream: "Certificate course in Marketing", subjects: [] },
                { stream: "Certificate course in HRM", subjects: [] },
                { stream: "Certificate course in English", subjects: [] },
                { stream: "Certificate course in ICT", subjects: [] }
            ]
        }
    ];

    const freeCoursesArt = ["English Certificate", "IT Certificate"];
    const freeCoursesCommerceTech = ["English diploma", "IT diploma", "HRM diploma", "Marketing diploma"];

    const handleMenuClick = (event: React.MouseEvent<HTMLElement>, student: any) => {
        setAnchorEl(event.currentTarget);
        setSelectedStudent(student);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const showAlert = (description: string, type: "success" | "error" | "warning") => {
        setAlertDescription(description);
        setAlertType(type);
        setAlertOpen(true);
    };

    const handleView = () => {
        if (!selectedStudent) return;
        setViewDialogOpen(true);
    };

    const handlePaymentOpen = () => {
        if (!selectedStudent) return;
        // Prefill with 3 installments: today, +30, +60
        handleGetSubjectId()
        handleGetPaymentPlan()
        const defaultCount = 3;
        setInstallmentsCount(String(defaultCount));
        const dates = Array.from({ length: defaultCount }, (_, i) => dayjs().add(i * 30, 'day'));
        setInstallmentDates(dates);
        const total = parseFloat(paymentAmount || '0');
        const per = defaultCount > 0 ? (total / defaultCount).toFixed(2) : '0.00';
        // setInstallmentAmounts(Array(defaultCount).fill(per));
        setPaymentModalOpen(true);
        handleMenuClose();
    };

    const handleEdit = () => {

        //console.log(selectedStudent);


        if (!selectedStudent) return;
        setName(selectedStudent.fullName);
        setNic(selectedStudent.studentNic);
        setDob(selectedStudent.dob ? dayjs(selectedStudent.dob) : null);
        setEmail(selectedStudent.email);
        setContactNumber(selectedStudent.contactNumber);
        setParentContactNumber(selectedStudent.parentContactNumber);
        setAddress(selectedStudent.address);
        setGender(selectedStudent.gender);
        const details = JSON.parse(selectedStudent?.userSubjects?.[0]?.subjectDetails || '{}');
        setSelectedProgramme(details.Programme || "default");
        setSelectedStream(details.Stream || "default");
        setUserSubjects(details.Subjects || []);
        setSelectedFreeCourses(selectedStudent?.userSubjects?.[0]?.freeCourses || []);
        setIsViewMode(true);
        setOpenModal(true);
    };

    const handleDelete = async (id: any) => {
        try {
            await deleteStudent(token, id);
            showAlert("Student deleted successfully", "success");
            handleFetchStudents();
        } catch (error: any) {
            showAlert(error.response.data.message, "error");
        }
        setIsOpen(false);
    };

    useEffect(() => {
        handleFetchStudents();
    }, []);

    useEffect(() => {
        handleSearch(searchTerm);
    }, [students, searchTerm]);

    const handleFetchStudents = async () => {
        try {
            const res = await getStudents(token)
            setStudents(res);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSearch = (term: string) => {
        const lower = term.toLowerCase();
        const filtered = students.filter(
            (student) =>
                student.fullName.toLowerCase().includes(lower) ||
                student.email.toLowerCase().includes(lower)
        );
        setFilteredStudents(filtered);
        setCurrentPage(1);
    };

    const paginatedStudents = filteredStudents.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    const totalPages = Math.ceil(filteredStudents.length / ITEMS_PER_PAGE);

    const validateForm = () => {
        if (!name || !email || !contactNumber || !password || !address || !parentContactNumber || !gender) {
            showAlert("Please fill in all fields", "error");
            return false;
        }
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            showAlert("Please enter a valid email address", "error");
            return false;
        }
        const contactPattern = /^\d{10}$/;
        if (!contactPattern.test(contactNumber)) {
            showAlert("Please enter a valid contact number", "error");
            return false;
        }
        const emergencyContactPattern = /^\d{10}$/;
        if (!emergencyContactPattern.test(parentContactNumber)) {
            showAlert("Please enter a valid parent contact number", "error");
            return false;
        }
        return true;
    }

    const validateUpdateForm = () => {
        if (!name || !contactNumber || !address || !parentContactNumber || !gender) {
            showAlert("Please fill in all fields", "error");
            return false;
        }
        const contactPattern = /^\d{9}$/;
        if (!contactPattern.test(contactNumber)) {
            showAlert("Please enter a valid contact number", "error");
            return false;
        }
        const emergencyContactPattern = /^\d{9}$/;
        if (!emergencyContactPattern.test(parentContactNumber)) {
            showAlert("Please enter a valid parent contact number", "error");
            return false;
        }
        return true;
    }

    const handleAddStudent = async () => {

        if (selectedProgramme === "Fast track A/L") {
            if (selectedStream === "Arts Stream" || selectedStream === "Commerce Stream" || selectedStream === "Technology Stream") {
                if (userSubjects.length === 0) {
                    showAlert("Please select at least one subject", "error");
                    return;
                }
            }
        }

        setIsLoading(true);
        if (!validateForm()) {
            setIsLoading(false);
            return;
        }

        const correctedDob = new Date(dob);
        correctedDob.setHours(correctedDob.getHours() + 6); // Add 6 hours

        const newStudent: StudentDetails = {
            fullName: name,
            encodedPassword: password,
            email,
            address,
            contactNumber: Number(contactNumber),
            parentContactNumber: Number(parentContactNumber),
            dob: correctedDob.toISOString().split("T")[0], // keep only YYYY-MM-DD
            gender,
            programme: selectedProgramme,
            stream: selectedStream,
            studentNic: nic,
            subjects: userSubjects,
            freeCourses: selectedFreeCourses,
            scholarshipCode: "",
        };


        try {
            await register(newStudent);
            setTimeout(() => {
                setIsLoading(false);
                handleResetForm();
                handleFetchStudents();
                setOpenModal(false);
                showAlert("Student created successfully", "success");
            }, 3000);
        } catch (error: any) {
            setIsLoading(false);
            showAlert(error.response.data.message, "error");
        }
    };

    const handleUpdateStudent = async () => {
        setIsLoading(true);
        if (!validateUpdateForm()) {
            setIsLoading(false);
            return;
        }

        const correctedDob = new Date(dob);
        correctedDob.setHours(correctedDob.getHours() + 6);

        const updatedStudent = {
            id: selectedStudent.id,
            fullName: name,
            email,
            contactNumber,
            parentContactNumber,
            dob: correctedDob.toISOString().split("T")[0],
            address,
            gender,
            studentNic: nic,
        };

        try {
            await updateStudent(token, updatedStudent);
            setTimeout(() => {
                setIsLoading(false);
                handleResetForm();
                handleFetchStudents();
                setOpenModal(false);
                showAlert("Student updated successfully", "success");
            }, 3000);
        } catch (error: any) {
            setIsLoading(false);
            showAlert(error.response.data.message, "error");
        }
    };

    const handleResetPassword = async () => {
        setIsLoading(true);
        try {
            await resetStudentPassword(token, selectedStudent.email, selectedStudent.email.split("@")[0]);
            setTimeout(() => {
                setIsLoading(false);
                handleResetForm();
                handleFetchStudents();
                setOpenModal(false);
                showAlert("Password reset successfully. Your new password is: " + selectedStudent.email.split("@")[0], "success");
            }, 3000);
        } catch (error: any) {
            setIsLoading(false);
            showAlert(error.response.data.message, "error");
        }
    }

    /**
     * Save payment. If `enteredAmount` is provided use it.
     * Otherwise determine the next editable installment amount dynamically:
     * - compute paidCount from pPlan.installments (remaining) and duration (installmentsCount)
     * - pick installmentAmounts[nextIndex] (next unpaid)
     * - fallback to paymentAmount
     */
    const handleSave = async (enteredAmount?: string) => {
        setIsLoading(true);
        try {
            // try explicit param first
            let amount = enteredAmount ? parseFloat(enteredAmount) : NaN;
            let installmentIndex = 0;

            if (Number.isNaN(amount)) {
                // determine next unpaid installment index
                const duration = parseInt(installmentsCount || "0", 10) || installmentAmounts.length;
                const remaining = Number.isFinite(Number(pPlan?.installments)) ? Number(pPlan.installments) : null;
                let paidCount = 0;
                if (remaining !== null && !Number.isNaN(remaining)) {
                    paidCount = Math.max(0, duration - remaining);
                }
                installmentIndex = Math.min(Math.max(0, paidCount), Math.max(0, installmentAmounts.length - 1));

                // validate that a value exists for this installment
                const nextInstallmentRaw = (installmentAmounts[installmentIndex] ?? "").toString().trim();
                if (!nextInstallmentRaw) {
                    setIsLoading(false);
                    showAlert("Please enter installment first", "warning");
                    return;
                }

                // parse the installment value
                amount = parseFloat(nextInstallmentRaw) || 0;
            }

            // Validate: entered amount must not exceed due amount
            const dueAmountVal = parseFloat(String(pPlan?.dueAmount || "0")) || 0;
            if (dueAmountVal > 0 && Number.isFinite(amount) && amount > dueAmountVal) {
                setIsLoading(false);
                showAlert(
                    `Entered amount (${Number(amount).toFixed(2)}) cannot exceed due amount (${Number(dueAmountVal).toFixed(2)}).`,
                    "warning"
                );
                return;
            }

            // Confirm with user before saving
            const confirmed = window.confirm(
                "Are you sure you want to save this payment?. This action cannot be undone. (Please make sure the details are correct.)"
            );
            if (!confirmed) {
                setIsLoading(false);
                return;
            }

            // prepare body
            const durationGlobal = parseInt(installmentsCount || "0", 10) || installmentAmounts.length;
            const remainingGlobal = Number.isFinite(Number(pPlan?.installments)) ? Number(pPlan.installments) : null;
            let paidCountGlobal = 0;
            if (remainingGlobal !== null && !Number.isNaN(remainingGlobal)) {
                paidCountGlobal = Math.max(0, durationGlobal - remainingGlobal);
            }
            const currentInstallmentIndex = Math.min(Math.max(0, paidCountGlobal), Math.max(0, installmentAmounts.length - 1));
            const isLast = currentInstallmentIndex === (durationGlobal - 1);

            const body: any = {
                paymentAmount: amount,
                updatedBy: parseInt(sessionStorage.getItem("adminId") || "0"),
                paymentDate: new Date().toISOString()
            };

            // If last installment ensure duePayment is passed if needed
            if (isLast) {
                const dueVal = parseFloat(String(pPlan?.dueAmount || "0")) || 0;
                if (dueVal > 0) {
                    body.paymentAmount = dueVal;
                    body.duePayment = dueVal;
                } else {
                    body.duePayment = body.paymentAmount;
                }
            }

            await pay(token, pPlan.id, body);
            setIsLoading(false);
            handleGetPaymentPlan();
            showAlert(`Payment of ${Number(body.paymentAmount).toFixed(2)} saved successfully`, "success");
        } catch (error) {
            setIsLoading(false);
            showAlert("Payment failed", "error");
            console.error("handleSave error:", error);
        } finally {
            setIsLoading(false);
        }
    }
    // Payment validation: disable Save if entered installment amount exceeds due amount
    const dueAmountNumber = parseFloat(String(pPlan?.dueAmount ?? "0")) || 0;
    const durationForUiValidation = parseInt(installmentsCount || "0", 10) || installmentAmounts.length;
    const remainingForUiValidation = Number.isFinite(Number(pPlan?.installments)) ? Number(pPlan.installments) : null;
    const nextInstallmentIndexForUi = (remainingForUiValidation !== null && !Number.isNaN(remainingForUiValidation))
        ? Math.min(
            Math.max(0, durationForUiValidation - remainingForUiValidation),
            Math.max(0, installmentAmounts.length - 1)
        )
        : 0;
    const enteredInstallmentAmountForUi = parseFloat(String((installmentAmounts[nextInstallmentIndexForUi] ?? "")).trim());
    const isEnteredAmountGreaterThanDue = dueAmountNumber > 0
        && Number.isFinite(enteredInstallmentAmountForUi)
        && enteredInstallmentAmountForUi > dueAmountNumber;

    const handleResetForm = () => {
        setName("");
        setPassword("");
        setEmail("");
        setAddress("");
        setContactNumber("");
        setParentContactNumber("");
        setNic("");
        setGender("");
        setAdminType(1);
    }

    function handleSubjectChange(subject: string): void {
        //console.log(subject);

        if (userSubjects.includes(subject)) {
            setUserSubjects((prev) => prev.filter((s) => s !== subject));
        } else {
            setUserSubjects((prev) => [...prev, subject]);
        }
    }

    function handleFreeCourseChange(course: string): void {
        if (selectedFreeCourses.includes(course)) {
            setSelectedFreeCourses((prev) => prev.filter((c) => c !== course));
        } else {
            setSelectedFreeCourses((prev) => [...prev, course]);
        }
    }

    const handleViewSubjects = () => {
        setOpenDetailsDialog(true);
        if (!selectedStudent) return;
        setName(selectedStudent.fullName);
        setNic(selectedStudent.studentNic);
        setDob(selectedStudent.dob ? dayjs(selectedStudent.dob) : null);
        setEmail(selectedStudent.email);
        setContactNumber(selectedStudent.contactNumber);
        setParentContactNumber(selectedStudent.parentContactNumber);
        setAddress(selectedStudent.address);
        setGender(selectedStudent.gender);
        const details = JSON.parse(selectedStudent?.userSubjects?.[0]?.subjectDetails || '{}');
        setSelectedProgramme(details.Programme || "default");
        setSelectedStream(details.Stream || "default");
        setUserSubjects(details.Subjects || []);
        setSelectedFreeCourses(selectedStudent?.userSubjects?.[0]?.freeCourses || []);
    };

    const handleBanUnbanStudent = async () => {
        setIsLoading(true);
        try {
            await banUnbanStudent(token, selectedStudent.id, selectedStudent?.isInactive === 0 ? true : false);
            setTimeout(() => {
                setIsLoading(false);
                handleFetchStudents();
                setOpenModal(false);
                showAlert(`Student ${selectedStudent?.isInactive === 0 ? "banned" : "unbanned"} successfully`, "success");
            }, 3000);
        } catch (error: any) {
            setIsLoading(false);
            showAlert(error.response.data.message, "error");
        }
    };

    const handleFilter = () => {
        if (!flag) {
            const filtered = students.filter(
                (student) =>
                    student.isInactive === 1
            );
            setFilteredStudents(filtered);
            setCurrentPage(1);
            setFlag(true);
        } else {
            setFilteredStudents(students);
            setCurrentPage(1);
            setFlag(false);
        }
    }

    const handleExtendDueDate = async () => {
        setIsLoading(true);
        try {
            await extendDueDate(token, selectedStudent.id, extensionWeeks);
            window.location.reload();
            showAlert(`Due date extended successfully for the student: ${selectedStudent.fullName}`, "success");
        } catch (error) {
            showAlert("Failed to extend due date", "error");
            setIsLoading(false);
        }
    }

    return (
        <div className="comman-outer">
            <Dialogbox
                open={isOpen}
                title="Delete Student"
                content="Are you sure you want to delete this student?"
                agreeButtonText="Delete"
                disagreeButtonText="Cancel"
                onAgree={() => handleDelete(selectedStudent.id)}
                onDisagree={() => setIsOpen(false)}
                onClose={() => setIsOpen(false)}
            />
            <Dialogbox
                open={isOpen2}
                title="Reset Password"
                content="Are you sure you want to reset the password for this student?"
                agreeButtonText="Reset"
                disagreeButtonText="Cancel"
                onAgree={() => handleResetPassword()}
                onDisagree={() => setIsOpen2(false)}
                onClose={() => setIsOpen2(false)}
            />
            <Dialogbox
                open={isOpen3}
                title={selectedStudent?.isInactive === 0 ? "Ban Student" : "Unban Student"}
                content={`Are you sure you want to ${selectedStudent?.isInactive === 0 ? "ban" : "unban"} this student?`}
                agreeButtonText={selectedStudent?.isInactive === 0 ? "Ban" : "Unban"}
                disagreeButtonText="Cancel"
                onAgree={() => handleBanUnbanStudent()}
                onDisagree={() => setIsOpen3(false)}
                onClose={() => setIsOpen3(false)}
            />
            <CustomAlert
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
                description={alertDescription}
                type={alertType}
                timeout={3000}
            />
            <Spinner isLoading={isLoading} />
            <Dialog
                open={viewDialogOpen}
                onClose={() => setViewDialogOpen(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: { backgroundColor: "#c6c2c2e3", color: "white", paddingBottom: 2, borderRadius: 2, boxShadow: 24, border: "1px solid #ffffffff" },
                }}
            >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "1px solid #555", backgroundColor: "#393939", padding: "25px 16px" }}>
                    <h3>Student Details</h3>

                </div>

                <Grid container spacing={2} style={{ padding: "25px 16px", color: "white", backgroundColor: "#6c6b6bff" }} className="form-grid">
                    <Grid item xs={12} sm={6}>
                        <strong>Name:</strong> {selectedStudent?.fullName}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>Email:</strong> {selectedStudent?.email}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>Contact:</strong> {selectedStudent?.contactNumber}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>Contact 2:</strong> {selectedStudent?.parentContactNumber}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>Gender:</strong> {selectedStudent?.gender}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>Address:</strong> {selectedStudent?.address}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>DOB:</strong> {selectedStudent?.dob.slice(0, 10)}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <strong>NIC:</strong> {selectedStudent?.studentNic}
                    </Grid>

                    <Grid item xs={12} sm={12} style={{ display: "flex", justifyContent: "center", marginTop: "0px" }}>
                        <Divider sx={{ width: "90%", borderColor: "#555", my: 2 }} />
                    </Grid>

                    {/* add view subjects button */}
                    <Grid item xs={12} sm={12} style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                        <Button variant="contained" className="primary-btn" onClick={handleViewSubjects}>
                            View Faculty Details
                        </Button>
                    </Grid>
                    {/* 
          {selectedStudent?.instructorSubjects.map((i:any) => {
            const label = `${i.programme}, ${i.stream}${i.subject ? `, ${i.subject}` : ""}`;
            return (
              <Grid item xs={12} sm={6} key={label}>
                <strong>Subject:</strong> {label}
              </Grid>
            );
          })} */}
                </Grid>
            </Dialog>

            <Dialog
                fullScreen
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}

            >
                <div className="full-modal-title-outer">
                    <div style={{ color: "white" }}>
                        Faculty Details
                    </div>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={() => setOpenDetailsDialog(false)}
                        aria-label="close"
                    >
                        <CloseOutlined style={{ color: "white" }} />
                    </IconButton>
                </div>

                <List style={{ marginTop: "64px", backgroundColor: "#8b8a8a", color: "black" }}>
                    <ListItemButton>
                        <ListItemText primary="Student Name" secondary={selectedStudent?.fullName} />
                    </ListItemButton>
                    <Divider />
                    <ListItemButton>
                        <ListItemText
                            primary="Enrolled Stream"
                            secondary={selectedStream}
                        />
                    </ListItemButton>
                    <Divider />
                    <ListItemButton>
                        <ListItemText
                            primary="Enrolled Programme"
                            secondary={selectedProgramme}
                        />
                    </ListItemButton>
                    <Divider />
                    <ListItemButton>
                        <ListItemText
                            primary="Enrolled Subjects"
                            secondary={userSubjects.join(", ")}
                        />
                    </ListItemButton>
                    <Divider />
                    <ListItemButton>
                        <ListItemText
                            primary="Free Courses"
                            secondary={selectedFreeCourses.join(", ")}
                        />
                    </ListItemButton>
                </List>
            </Dialog>


            {!openModal && (
                <div>
                    <TableToolbar
                        title="Student List"
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        buttonText="Student"
                        onButtonClick={() => setOpenModal(true)}
                        buttonIcon={<PlusOutlined style={{ fontSize: "14px", color: "black" }} />}
                        isFiltered={true}
                        onFilterClick={handleFilter}
                    />
                    <div className="space-bar"></div>

                    {paginatedStudents.length > 0 ? paginatedStudents.map((student) => (
                        <div style={{ backgroundColor: student.isInactive ? "#ff190054" : "" }} className="card-outer" key={student.id}>
                            <div className="card-outer1">
                                <p className="t-card">{student.fullName}</p>
                                <p className="t-card">{student.email}</p>
                                <p className="t-card">{student.contactNumber}</p>
                                <p className="t-card">{student.studentNic}</p>
                            </div>

                            <IconButton onClick={(e) => handleMenuClick(e, student)}>
                                <MoreVert style={{ color: "white" }} />
                            </IconButton>
                        </div>
                    )) : (
                        <div style={{ justifyContent: "center", alignItems: "center" }} className="card-outer">No students found.</div>
                    )}

                    <div className="pagination-footer">
                        <span style={{ fontSize: "13px" }}>
                            Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1} -{" "}
                            {Math.min(currentPage * ITEMS_PER_PAGE, filteredStudents.length)} of{" "}
                            {filteredStudents.length}
                        </span>
                        <div className="pagination-buttons">
                            <button
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage((prev) => prev - 1)}
                            >
                                Prev
                            </button>
                            {[...Array(totalPages)].map((_, i) => (
                                <button
                                    key={i}
                                    onClick={() => setCurrentPage(i + 1)}
                                    className={currentPage === i + 1 ? "active" : ""}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            <button
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage((prev) => prev + 1)}
                            >
                                Next
                            </button>
                        </div>
                    </div>

                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                        <MenuItem onClick={handlePaymentOpen}>Payments</MenuItem>
                        <MenuItem onClick={() => {
                            handleView();
                            handleMenuClose();
                        }}>View</MenuItem>
                        <MenuItem onClick={() => {
                            handleEdit();
                            handleMenuClose();
                        }}>Edit</MenuItem>
                        <MenuItem onClick={() => {
                            setIsOpen(true);
                            setSelectedStudent(selectedStudent);
                            handleMenuClose();
                        }}>Delete</MenuItem>
                        <MenuItem onClick={() => {
                            setIsOpen3(true);
                            setSelectedStudent(selectedStudent);
                            handleMenuClose();
                        }}>{selectedStudent?.isInactive === 0 ? "Ban Student" : "Unban Student"}</MenuItem>
                        <MenuItem onClick={() => {
                            setIsOpen2(true);
                            setSelectedStudent(selectedStudent);
                            handleMenuClose();
                        }}>Reset Password</MenuItem>
                    </Menu>
                </div>
            )}

            {openModal && (
                <div>
                    <div className="table-title-outer">
                        {isViewMode ? (
                            <div className="table-title">Edit Student</div>
                        ) : (
                            <div className="table-title">Add New Student</div>
                        )}
                        <IconButton
                            className="close-btn"
                            onClick={() => {
                                setIsViewMode(false);
                                window.location.reload();
                                setOpenModal(false);
                            }}
                            style={{ color: "white" }}
                        >
                            <Close style={{ color: "white" }} />
                        </IconButton>
                    </div>
                    <div className="space-bar"></div>
                    <div className="card-outer">
                        <Grid container spacing={2} style={{ padding: "16px" }} className="form-grid ">
                            <Grid item xs={12} sm={6} md={isViewMode ? 4 : 4}>
                                {/* add label */}
                                <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Name</FormLabel>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Name"
                                    size="small"
                                    value={name}
                                    onChange={(e) => {
                                        const onlyText = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                        setName(onlyText);
                                    }}
                                    sx={{
                                        backgroundColor: "black",
                                        input: {
                                            color: "#ffffff",
                                            "::placeholder": {
                                                color: "grey",
                                                opacity: 1,
                                            },
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: "#555",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#aaa",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "gray",
                                            },
                                        },
                                    }}
                                />

                            </Grid>
                            {!isViewMode && (
                                <Grid item xs={12} sm={6} md={4}>
                                    <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Password</FormLabel>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Password"
                                        type="text"
                                        size="small"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        sx={{
                                            backgroundColor: "black",
                                            input: {
                                                color: "#ffffff",
                                                "::placeholder": {
                                                    color: "grey",
                                                    opacity: 1,
                                                },
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "#555",
                                                },
                                                "&:hover fieldset": {
                                                    borderColor: "#aaa",
                                                },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "gray",
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                            )}

                            {!isViewMode && (
                                <Grid item xs={12} sm={6} md={4}>
                                    <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Email</FormLabel>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Email"
                                        size="small"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        sx={{
                                            backgroundColor: "black",
                                            input: {
                                                color: "#ffffff",
                                                "::placeholder": {
                                                    color: "grey",
                                                    opacity: 1,
                                                },
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "#555",
                                                },
                                                "&:hover fieldset": {
                                                    borderColor: "#aaa",
                                                },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "gray",
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12} sm={6} md={isViewMode ? 4 : 6}>
                                <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Contact Number</FormLabel>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Contact Number"
                                    size="small"
                                    value={contactNumber}
                                    onChange={(e) => setContactNumber(e.target.value)}
                                    sx={{
                                        backgroundColor: "black",
                                        input: {
                                            color: "#ffffff",
                                            "::placeholder": {
                                                color: "grey",
                                                opacity: 1,
                                            },
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: "#555",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#aaa",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "gray",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={isViewMode ? 4 : 6}>
                                <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Parent Contact Number</FormLabel>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Parent Contact Number"
                                    size="small"
                                    value={parentContactNumber}
                                    onChange={(e) => setParentContactNumber(e.target.value)}
                                    sx={{
                                        backgroundColor: "black",
                                        input: {
                                            color: "#ffffff",
                                            "::placeholder": {
                                                color: "grey",
                                                opacity: 1,
                                            },
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: "#555",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#aaa",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "gray",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Address</FormLabel>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Address"
                                    size="small"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    sx={{
                                        backgroundColor: "black",
                                        input: {
                                            color: "#ffffff",
                                            "::placeholder": {
                                                color: "grey !important",
                                                opacity: 1,
                                            },
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: "#555",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#aaa",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "gray",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>NIC No</FormLabel>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="NIC No"
                                    size="small"
                                    value={nic}
                                    onChange={(e) => setNic(e.target.value)}
                                    sx={{
                                        backgroundColor: "black",
                                        input: {
                                            color: "#ffffff",
                                            "::placeholder": {
                                                color: "grey",
                                                opacity: 1,
                                            },
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: "#555",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#aaa",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "gray",
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl sx={{ textAlign: 'right', width: "100%" }} variant="outlined">
                                    <FormHelperText sx={{ ml: 0.5, mb: 1, fontSize: '14px', color: '#3d3d3dff' }}>
                                        Date of Birth
                                    </FormHelperText>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label=""
                                            value={dob}
                                            onChange={(newValue: any) => setDob(newValue)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Date of Birth"
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: "black",
                                                        svg: { color: "#ffffff" },
                                                        input: {
                                                            color: "#ffffff",
                                                            "::placeholder": {
                                                                color: "grey",
                                                                opacity: 1,
                                                            },
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#555",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "#aaa",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "gray",
                                                            },
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl component="fieldset">
                                    <FormLabel
                                        component="legend"
                                        sx={{
                                            color: "#3d3d3dff",
                                            "&.Mui-focused": {
                                                color: "#3d3d3dff", // Prevent blue on focus
                                            },
                                            "&.MuiFormLabel-root": {
                                                color: "#3d3d3dff",
                                            },
                                        }}
                                    >
                                        Gender
                                    </FormLabel>

                                    <RadioGroup
                                        row
                                        value={gender}
                                        onChange={(e) => setGender(e.target.value)}
                                    >
                                        <FormControlLabel
                                            value="male"
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: "#8f8d8dff", // default color
                                                        "&.Mui-checked": {
                                                            color: "#bbaf05", // yellow when selected
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Male"
                                        />
                                        <FormControlLabel
                                            value="female"
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: "#8f8d8dff",
                                                        "&.Mui-checked": {
                                                            color: "#bbaf05", // yellow when selected
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Female"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Divider sx={{ width: "105%", borderColor: "#555", my: 2 }} />

                            {!isViewMode && (
                                <>
                                    <Grid item xs={12}>
                                        <FormLabel component="legend" sx={{ color: "#3d3d3dff" }}>
                                            Student Subjects
                                        </FormLabel>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={6}>
                                        <FormControl fullWidth>
                                            <Select
                                                value={selectedProgramme}
                                                disabled={isViewMode}
                                                onChange={(e) => {
                                                    setSelectedProgramme(e.target.value)
                                                    setSelectedStream("default");
                                                    setUserSubjects([]); // Clear selected subjects when programme changes
                                                }}
                                                size="small"
                                                sx={{
                                                    backgroundColor: "black",
                                                    color: "#ffffff",
                                                    "& .MuiSvgIcon-root": {
                                                        color: "#ffffff",
                                                    },
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#555",
                                                    },
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#aaa",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "gray",
                                                    },
                                                    "& .MuiSelect-icon": {
                                                        color: "#ffffff",
                                                    }
                                                }}
                                            >
                                                <MenuItem disabled value="default">Select a programme</MenuItem>
                                                {programmes.map((programme) => (
                                                    <MenuItem key={programme.programme} value={programme.programme}>
                                                        {programme.programme}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={6}>
                                        <FormControl fullWidth>
                                            <Select
                                                value={selectedStream}
                                                onChange={(e) => {
                                                    setSelectedStream(e.target.value);
                                                    setUserSubjects([]);
                                                    setSelectedFreeCourses([]);
                                                }}
                                                size="small"
                                                disabled={selectedProgramme === "default" || programmes.find(p => p.programme === selectedProgramme)?.streams.length === 0}
                                                sx={{
                                                    backgroundColor: "black",
                                                    color: "#ffffff",
                                                    "& .MuiSvgIcon-root": {
                                                        color: "#ffffff",
                                                    },
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#555",
                                                    },
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#aaa",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "gray",
                                                    },
                                                    "& .MuiSelect-icon": {
                                                        color: "#ffffff",
                                                    }
                                                }}
                                            >
                                                <MenuItem disabled value="default">Select a stream</MenuItem>
                                                {selectedProgramme !== "default" && programmes.find(p => p.programme === selectedProgramme)?.streams.map((stream) => (
                                                    <MenuItem key={stream.stream} value={stream.stream}>
                                                        {stream.stream}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* add check boxes */}
                                    <Grid item xs={12}>
                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", backgroundColor: "#1e1e1e", padding: "15px", borderRadius: "0px", maxHeight: "400px", overflowY: "auto", color: "#9a9696ff" }}>
                                            {programmes
                                                .find(p => p.programme === selectedProgramme)?.streams
                                                .find(s => s.stream === selectedStream)?.subjects.map((subject, index) => (
                                                    <div key={index}>
                                                        <Checkbox
                                                            checked={userSubjects.includes(subject)}
                                                            onChange={() => handleSubjectChange(subject)}
                                                            color="default"
                                                            sx={{
                                                                color: "#8f8d8dff",
                                                                "&.Mui-checked": { color: "#bbaf05" },
                                                            }}
                                                        />
                                                        {subject}
                                                    </div>
                                                ))}
                                        </div>
                                    </Grid>
                                    {
                                        selectedStream !== "default" && selectedStream !== "" && (
                                            <>
                                                <Grid item xs={12}>
                                                    <FormLabel component="legend" sx={{ color: "#3d3d3dff" }}>
                                                        Courses Offered Free of Charge
                                                    </FormLabel>
                                                </Grid>

                                                {selectedStream === "Arts Stream" ? (
                                                    <Grid item xs={12}>
                                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", backgroundColor: "#1e1e1e", padding: "15px", borderRadius: "0px", maxHeight: "400px", overflowY: "auto", color: "#9a9696ff" }}>
                                                            {freeCoursesArt.map((subject, index) => (
                                                                <div key={index}>
                                                                    <Checkbox
                                                                        checked={selectedFreeCourses.includes(subject)}
                                                                        onChange={() => handleFreeCourseChange(subject)}
                                                                        color="default"
                                                                        sx={{
                                                                            color: "#8f8d8dff",
                                                                            "&.Mui-checked": { color: "#bbaf05" },
                                                                        }}
                                                                    />
                                                                    {subject}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Grid>
                                                ) : (
                                                    selectedStream === "Commerce Stream" || selectedStream === "Technology Stream" ? (
                                                        <Grid item xs={12}>
                                                            <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", backgroundColor: "#1e1e1e", padding: "15px", borderRadius: "0px", maxHeight: "400px", overflowY: "auto", color: "#9a9696ff" }}>
                                                                {freeCoursesCommerceTech.map((subject, index) => (
                                                                    <div key={index}>
                                                                        <Checkbox
                                                                            checked={selectedFreeCourses.includes(subject)}
                                                                            onChange={() => handleFreeCourseChange(subject)}
                                                                            color="default"
                                                                            sx={{
                                                                                color: "#8f8d8dff",
                                                                                "&.Mui-checked": { color: "#bbaf05" },
                                                                            }}
                                                                        />
                                                                        {subject}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </Grid>
                                                    ) : (
                                                        <Grid item xs={12}>
                                                            <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", backgroundColor: "#1e1e1e", padding: "15px", borderRadius: "0px", maxHeight: "400px", overflowY: "auto", color: "#9a9696ff" }}>
                                                                No free courses available for this stream
                                                            </div>
                                                        </Grid>
                                                    ))}
                                            </>
                                        )
                                    }

                                    <Grid item xs={12} sm={6} md={6}>
                                        <FormLabel component="legend" sx={{ color: "#3d3d3dff", mb: 1 }}>Scholarship Code</FormLabel>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Scholarship Code"
                                            size="small"
                                            value={scholarshipCode}
                                            onChange={(e) => setScholarshipCode(e.target.value)}
                                            sx={{
                                                backgroundColor: "black",
                                                input: {
                                                    color: "#ffffff",
                                                    "::placeholder": {
                                                        color: "grey",
                                                        opacity: 1,
                                                    },
                                                },
                                                "& .MuiOutlinedInput-root": {
                                                    "& fieldset": {
                                                        borderColor: "#555",
                                                    },
                                                    "&:hover fieldset": {
                                                        borderColor: "#aaa",
                                                    },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "gray",
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>

                                </>
                            )}

                        </Grid>
                    </div>
                    <div className="pagination-footer">
                        <div></div>
                        {isViewMode ? (
                            <Button
                                className="primary-btn"
                                variant="contained"
                                size="small"
                                onClick={handleUpdateStudent}
                                startIcon={<PlusOutlined style={{ fontSize: "14px", color: "black" }} />}
                                disabled={!name || !contactNumber || !parentContactNumber || !address || !gender || !nic || !dob}
                            >
                                Update Student
                            </Button>
                        ) : (
                            <Button
                                className="primary-btn"
                                variant="contained"
                                size="small"
                                onClick={handleAddStudent}
                                startIcon={<PlusOutlined style={{ fontSize: "14px", color: "black" }} />}
                                disabled={!name || !email || !contactNumber || !parentContactNumber || !password || !address || !gender || !nic || !dob || selectedProgramme === "default" || selectedStream === "default"}
                            >
                                Add Student
                            </Button>
                        )}

                    </div>
                </div>

            )}

            {/* Payment Modal - Full Screen */}
            <Dialog
                fullScreen
                open={paymentModalOpen}
                keepMounted
                disableEnforceFocus
                onClose={() => setPaymentModalOpen(false)}
                PaperProps={{ sx: { bgcolor: "#000000ff", color: "#fff" } }}
            >
                {/* Header */}
                <Box className="chat-header">
                    <DialogTitle className="chat-title">Payment Details</DialogTitle>
                    <IconButton edge="end" color="inherit" onClick={() => setPaymentModalOpen(false)} aria-label="close">
                        <CloseCircleFilled />
                    </IconButton>
                </Box>

                {/* Body */}
                <DialogContent className="chat-body" sx={{ bgcolor: '#0d0d0d', color: '#fff' }}>
                    {/* Student Information */}
                    <div style={{
                        backgroundColor: '#1a1a1a',
                        border: '1px solid #333',
                        borderRadius: '12px',
                        padding: '16px',
                        marginBottom: '16px'
                    }}>
                        <Typography variant="h6" sx={{ color: '#d9ae03', fontWeight: 600, mb: 1 }}>
                            Student Information
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Typography sx={{ color: '#aaa', fontSize: 13 }}>Name</Typography>
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 15,
                                        maxWidth: '100%',
                                        whiteSpace: 'normal',
                                        overflowWrap: 'anywhere',
                                        wordBreak: 'break-word',
                                        lineHeight: 1.3,
                                    }}
                                >
                                    {selectedStudent?.fullName || '—'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography sx={{ color: '#aaa', fontSize: 13 }}>Email</Typography>
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 15,
                                        maxWidth: '100%',
                                        whiteSpace: 'normal',
                                        overflowWrap: 'anywhere',
                                        wordBreak: 'break-word',
                                        lineHeight: 1.3,
                                    }}
                                >
                                    {selectedStudent?.email || '—'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography sx={{ color: '#aaa', fontSize: 13 }}>Contact</Typography>
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 15,
                                        maxWidth: '100%',
                                        whiteSpace: 'normal',
                                        overflowWrap: 'anywhere',
                                        wordBreak: 'break-word',
                                        lineHeight: 1.3,
                                    }}
                                >
                                    {selectedStudent?.contactNumber || '—'}
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>

                    {/* Payment Details */}
                    <div style={{
                        backgroundColor: '#1a1a1a',
                        border: '1px solid #333',
                        borderRadius: '12px',
                        padding: '16px'
                    }}>
                        <Typography variant="h6" sx={{ color: '#d9ae03', fontWeight: 600, mb: 2 }}>
                            Payment Details
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <FormLabel sx={{ color: '#aaa', fontSize: 13, mb: 1, display: 'block' }}>Total Amount (LKR)</FormLabel>
                                <TextField
                                    fullWidth
                                    type="number"
                                    placeholder="Enter total amount"
                                    variant="outlined"
                                    size="medium"
                                    inputProps={{
                                        readOnly: !btnVisible,
                                        min: 1,
                                        onWheel: (e) => (e.target as HTMLInputElement).blur(),
                                    }}
                                    value={paymentAmount}
                                    onKeyDown={(e) => { e.stopPropagation(); }}
                                    onFocus={(e) => { e.stopPropagation(); }}
                                    onChange={(e) => {
                                        setPaymentAmount(e.target.value);
                                        if (installmentsCount) {
                                            const count = parseInt(installmentsCount);
                                            const amount = parseFloat(e.target.value) || 0;
                                            const perInstallment = (amount / count).toFixed(2);
                                            // setInstallmentAmounts(Array(count).fill(perInstallment));
                                        }
                                    }}
                                    sx={{
                                        backgroundColor: '#111',
                                        '& .MuiOutlinedInput-root': {
                                            color: '#fff',
                                            '& fieldset': { borderColor: '#333' },
                                            '&:hover fieldset': { borderColor: '#555' },
                                            '&.Mui-focused fieldset': { borderColor: '#d9ae03' },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormLabel sx={{ color: '#aaa', fontSize: 13, mb: 1, display: 'block' }}>Number of Installments</FormLabel>
                                <TextField
                                    fullWidth
                                    type="number"
                                    placeholder="Enter installments count"
                                    variant="outlined"
                                    size="medium"
                                    inputProps={{
                                        readOnly: !btnVisible,
                                        min: 1,
                                        onWheel: (e) => (e.target as HTMLInputElement).blur(),
                                    }}
                                    // set readonly if !btnVisible
                                    value={installmentsCount}
                                    onKeyDown={(e) => { e.stopPropagation(); }}
                                    onFocus={(e) => { e.stopPropagation(); }}
                                    onChange={(e) => {
                                        const count = e.target.value;
                                        setInstallmentsCount(count);
                                        if (count && parseInt(count) > 0) {
                                            const numCount = parseInt(count);
                                            const dates = Array.from({ length: numCount }, (_, i) => dayjs().add(i * 30, 'day'));
                                            setInstallmentDates(dates);
                                            if (paymentAmount) {
                                                const amount = parseFloat(paymentAmount);
                                                const perInstallment = (amount / numCount).toFixed(2);
                                                // setInstallmentAmounts(Array(numCount).fill(perInstallment));
                                            } else {
                                                // setInstallmentAmounts(Array(numCount).fill('0.00'));
                                            }
                                        } else {
                                            setInstallmentDates([]);
                                            setInstallmentAmounts([]);
                                        }
                                    }}
                                    sx={{
                                        backgroundColor: '#111',
                                        '& .MuiOutlinedInput-root': {
                                            color: '#fff',
                                            '& fieldset': { borderColor: '#333' },
                                            '&:hover fieldset': { borderColor: '#555' },
                                            '&.Mui-focused fieldset': { borderColor: '#d9ae03' },
                                        },
                                    }}
                                />
                            </Grid>

                            {btnVisible && (
                                <Grid item xs={12}>
                                    <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 8 }}>
                                        <Button
                                            size="large"
                                            disabled={isLoading || paymentAmount === '' || installmentsCount === ''}
                                            className="primary-btn"
                                            onClick={handleCreatePaymentPlan}
                                        >
                                            Create Payment Plan
                                        </Button>
                                    </div>
                                </Grid>
                            )}

                            {!btnVisible && (
                                <>
                                    {installmentDates.length > 0 && pPlan?.dueAmount !== 0 && (
                                        <>
                                            <Grid item xs={12}>
                                                <Divider sx={{ borderColor: '#333', my: 2 }} />
                                                <Typography variant="subtitle1" sx={{ color: '#d9ae03', fontWeight: 600 }}>
                                                    Installment Schedule
                                                </Typography>
                                            </Grid>
                                            {(() => {
                                                const duration = parseInt(installmentsCount || "0", 10) || installmentAmounts.length;
                                                const remaining = Number.isFinite(Number(pPlan?.installments)) ? Number(pPlan.installments) : null;

                                                // New behaviour:
                                                // - If `remaining` is provided:
                                                //     show only the installment at index `duration - remaining`
                                                //     (e.g. remaining===duration -> show index 0, remaining===duration-1 -> show index 1)
                                                // - If `remaining === 0` -> show none
                                                // - If `remaining` is null -> fallback to previous dynamic behaviour (show next unpaid and previous readonly)
                                                if (remaining !== null && !Number.isNaN(remaining)) {
                                                    const showIndex = duration - Number(remaining); // zero-based index to display
                                                    if (showIndex < 0 || showIndex >= duration || installmentDates.length === 0) {
                                                        return null; // nothing to render (including case remaining === 0)
                                                    }

                                                    // prefer server-provided paymentExpirationDate if available
                                                    const date = pPlan?.paymentExpirationDate
                                                        ? dayjs(pPlan.paymentExpirationDate)
                                                        : (installmentDates[showIndex] || dayjs());
                                                    const isReadonly = false; // the visible single installment is editable (not a paid one)
                                                    const isLastInstallment = showIndex === (duration - 1);
                                                    // show stored installmentAmounts if present, otherwise fall back to server dueAmount for last
                                                    const amountValueSingle = installmentAmounts[showIndex] !== undefined && installmentAmounts[showIndex] !== ''
                                                        ? installmentAmounts[showIndex]
                                                        : (isLastInstallment && pPlan?.dueAmount
                                                            ? String(Number(pPlan.dueAmount).toFixed ? Number(pPlan.dueAmount).toFixed(2) : pPlan.dueAmount)
                                                            : '')
                                                    const amountDisabledSingle = isReadonly; // allow editing last installment

                                                    return (
                                                        <React.Fragment key={showIndex}>
                                                            <Grid item xs={12} sm={6}>
                                                                <FormLabel sx={{ color: '#aaa', fontSize: 13, mb: 1, display: 'block' }}>
                                                                    Installment {showIndex + 1} - Due Date
                                                                </FormLabel>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        value={date}
                                                                        // fully disabled: read-only display only
                                                                        disabled
                                                                        onChange={() => { /* no-op */ }}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                fullWidth
                                                                                size="medium"
                                                                                onKeyDown={(e) => { e.stopPropagation(); }}
                                                                                onFocus={(e) => { e.stopPropagation(); }}
                                                                                disabled={true}
                                                                                inputProps={{ ...params.inputProps, readOnly: true }}
                                                                                sx={{
                                                                                    backgroundColor: '#111',
                                                                                    // force disabled text/icon color to white
                                                                                    '& .MuiOutlinedInput-root': {
                                                                                        color: '#fff',
                                                                                        '& fieldset': { borderColor: '#333' },
                                                                                        '&.Mui-disabled': {
                                                                                            color: '#fff',
                                                                                            '& fieldset': { borderColor: '#333' },
                                                                                        },
                                                                                    },
                                                                                    '& .MuiInputBase-input.Mui-disabled': {
                                                                                        WebkitTextFillColor: '#fff', // for Chrome/Edge
                                                                                        color: '#fff',
                                                                                        opacity: 1,
                                                                                    },
                                                                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#333' },
                                                                                    '& .MuiSvgIcon-root': { color: '#fff' },
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <FormLabel sx={{ color: '#aaa', fontSize: 13, mb: 1, display: 'block' }}>
                                                                    Installment {showIndex + 1} - Amount (LKR)
                                                                </FormLabel>
                                                                <TextField
                                                                    fullWidth
                                                                    type="number"
                                                                    placeholder="Amount"
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    value={amountValueSingle}
                                                                    onKeyDown={(e) => { e.stopPropagation(); }}
                                                                    onFocus={(e) => {
                                                                        if (!amountDisabledSingle) (e.target as HTMLInputElement).select();
                                                                    }}
                                                                    onClick={(e) => {
                                                                        if (!amountDisabledSingle) (e.target as HTMLInputElement).select();
                                                                    }}
                                                                    onChange={(e) => {
                                                                        if (amountDisabledSingle) return;
                                                                        const newAmounts = [...installmentAmounts];
                                                                        newAmounts[showIndex] = e.target.value;
                                                                        setInstallmentAmounts(newAmounts);
                                                                    }}
                                                                    disabled={amountDisabledSingle}
                                                                    inputProps={{
                                                                        readOnly: amountDisabledSingle,
                                                                        onWheel: (e) => (e.target as HTMLInputElement).blur(),
                                                                    }}
                                                                    sx={{
                                                                        backgroundColor: '#111',
                                                                        // force disabled text to white and keep opacity
                                                                        '& .MuiOutlinedInput-root': {
                                                                            color: '#fff',
                                                                            '& fieldset': { borderColor: '#333' },
                                                                            '&:hover fieldset': { borderColor: '#555' },
                                                                            '&.Mui-focused fieldset': { borderColor: '#d9ae03' },
                                                                            '&.Mui-disabled': {
                                                                                color: '#fff',
                                                                            },
                                                                        },
                                                                        '& .MuiInputBase-input.Mui-disabled': {
                                                                            WebkitTextFillColor: '#fff',
                                                                            color: '#fff',
                                                                            opacity: 1,
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </React.Fragment>
                                                    );
                                                }

                                                // fallback: previous behaviour when pPlan.installments is not available
                                                // compute paidCount and show next unpaid plus previous paid as readonly
                                                let paidCount = 0;
                                                if (remaining === null) {
                                                    // try derive paid count from pPlan?.installments if available differently, else compute 0
                                                    // keep previous logic: paidCount = duration - remaining (not available) -> default 0
                                                    paidCount = 0;
                                                }

                                                const visibleCount = Math.min(duration || installmentDates.length, Math.max(1, paidCount + 1));

                                                // next unpaid index
                                                const nextIndex = paidCount;

                                                return installmentDates.slice(0, visibleCount).map((date, index) => {
                                                    const isReadonly = index < paidCount;
                                                    // if server provided paymentExpirationDate, use it for the next unpaid date field
                                                    const dateValue = (pPlan?.paymentExpirationDate && index === nextIndex)
                                                        ? dayjs(pPlan.paymentExpirationDate)
                                                        : date;
                                                    const isLast = index === (duration - 1);
                                                    // prefer user-entered installmentAmounts[index]; otherwise show server dueAmount for last index
                                                    const amountValue = (installmentAmounts[index] !== undefined && installmentAmounts[index] !== '')
                                                        ? installmentAmounts[index]
                                                        : (isLast && pPlan?.dueAmount ? String(Number(pPlan.dueAmount).toFixed ? Number(pPlan.dueAmount).toFixed(2) : pPlan.dueAmount) : '');
                                                    const amountDisabled = isReadonly; // allow editing last installment

                                                    return (
                                                        <React.Fragment key={index}>
                                                            <Grid item xs={12} sm={6}>
                                                                <FormLabel sx={{ color: '#aaa', fontSize: 13, mb: 1, display: 'block' }}>
                                                                    Installment {index + 1} - Date
                                                                </FormLabel>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        value={dateValue}
                                                                        // display-only: prevent opening / edits
                                                                        disabled
                                                                        onChange={() => { /* no-op */ }}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                fullWidth
                                                                                size="medium"
                                                                                onKeyDown={(e) => { e.stopPropagation(); }}
                                                                                onFocus={(e) => { e.stopPropagation(); }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <FormLabel sx={{ color: '#aaa', fontSize: 13, mb: 1, display: 'block' }}>
                                                                    Installment {index + 1} - Amount (LKR)
                                                                </FormLabel>
                                                                <TextField
                                                                    fullWidth
                                                                    type="number"
                                                                    placeholder="Amount"
                                                                    variant="outlined"
                                                                    size="medium"
                                                                    value={amountValue}
                                                                    onKeyDown={(e) => { e.stopPropagation(); }}
                                                                    onFocus={(e) => {
                                                                        if (!amountDisabled) {
                                                                            (e.target as HTMLInputElement).select();
                                                                        }
                                                                    }}
                                                                    onClick={(e) => {
                                                                        if (!amountDisabled) {
                                                                            (e.target as HTMLInputElement).select();
                                                                        }
                                                                    }}
                                                                    onChange={(e) => {
                                                                        if (amountDisabled) return;
                                                                        const newAmounts = [...installmentAmounts];
                                                                        newAmounts[index] = e.target.value;
                                                                        setInstallmentAmounts(newAmounts);
                                                                    }}
                                                                    disabled={amountDisabled}
                                                                    inputProps={{
                                                                        readOnly: amountDisabled,
                                                                        onWheel: (e) => (e.target as HTMLInputElement).blur(),
                                                                    }}
                                                                    sx={{
                                                                        backgroundColor: '#111',
                                                                        '& .MuiOutlinedInput-root': {
                                                                            color: '#fff',
                                                                            '& fieldset': { borderColor: '#333' },
                                                                            '&:hover fieldset': { borderColor: '#555' },
                                                                            '&.Mui-focused fieldset': { borderColor: '#d9ae03' },
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </React.Fragment>
                                                    );
                                                });
                                            })()}
                                        </>
                                    )}

                                    <>
                                        <Grid item xs={12}>
                                            <Divider sx={{ borderColor: '#333', my: 2 }} />
                                        </Grid>
                                        <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}></Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormLabel sx={{ color: '#aaa', fontSize: 13, mb: 1, display: 'block' }}>Due Payment</FormLabel>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                size="medium"
                                                value={pPlan?.dueAmount || '0.00'}
                                                inputProps={{ readOnly: true }}
                                                sx={{
                                                    backgroundColor: '#1a1a1a',
                                                    '& .MuiOutlinedInput-root': {
                                                        color: '#ff9800',
                                                        fontWeight: 600,
                                                        '& fieldset': { borderColor: '#333' },
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    </>
                                </>
                            )}
                        </Grid>
                        {!btnVisible && pPlan?.dueAmount !== 0 && (
                            <Grid item xs={12}>
                                <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 8 }}>
                                    {isPaymentExpired && (
                                        <Button
                                            size="large"
                                            variant="contained"
                                            sx={{
                                                backgroundColor: '#ff6b6b',
                                                color: '#fff',
                                                '&:hover': { backgroundColor: '#ff5252' }
                                            }}
                                            onClick={handleTemporaryUnlock}
                                            disabled={isLoading}
                                        >
                                            Temporary Unlock

                                        </Button>
                                    )}
                                    <Button
                                        size="large"
                                        className="primary-btn"
                                        onClick={() => handleSave()}
                                        disabled={isLoading || pPlan?.installments === 0 || isEnteredAmountGreaterThanDue}
                                    >
                                        Save
                                    </Button>
                                </div>
                            </Grid>
                        )}
                    </div>
                </DialogContent>
            </Dialog>

            {/* Unlock User Modal */}
            <Dialog
                open={unlockModalOpen}
                onClose={() => setUnlockModalOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{ sx: { bgcolor: "#000000ff", color: "#fff" } }}
            >
                {/* Header */}
                <Box className="chat-header">
                    <DialogTitle className="chat-title">Unlock User</DialogTitle>
                    <IconButton edge="end" color="inherit" onClick={() => setUnlockModalOpen(false)} aria-label="close">
                        <CloseCircleFilled />
                    </IconButton>
                </Box>

                {/* Body */}
                <DialogContent className="chat-body" sx={{ bgcolor: '#0d0d0d', color: '#fff', py: 3 }}>
                    <Grid container spacing={2}>
                        {/* Extension Weeks Section */}
                        <Grid item xs={12}>
                            <div style={{
                                backgroundColor: '#1a1a1a',
                                border: '1px solid #333',
                                borderRadius: '12px',
                                padding: '16px',
                                marginBottom: '12px'
                            }}>
                                <FormLabel sx={{ color: '#aaa', fontSize: 13, mb: 1, display: 'block' }}>
                                    Number of Weeks to Extend
                                </FormLabel>
                                <TextField
                                    fullWidth
                                    type="number"
                                    placeholder="Enter number of weeks"
                                    variant="outlined"
                                    size="medium"
                                    inputProps={{
                                        min: 1,
                                        onWheel: (e) => (e.target as HTMLInputElement).blur(),
                                    }}
                                    value={extensionWeeks}
                                    onChange={(e) => setExtensionWeeks(e.target.value)}
                                    onKeyDown={(e) => { e.stopPropagation(); }}
                                    onFocus={(e) => { e.stopPropagation(); }}
                                    sx={{
                                        backgroundColor: '#111',
                                        '& .MuiOutlinedInput-root': {
                                            color: '#fff',
                                            '& fieldset': { borderColor: '#333' },
                                            '&:hover fieldset': { borderColor: '#555' },
                                            '&.Mui-focused fieldset': { borderColor: '#d9ae03' },
                                        },
                                    }}
                                />
                            </div>
                        </Grid>

                        {/* Extend Due Date Section */}
                        <Grid item xs={12}>
                            <div style={{
                                backgroundColor: '#1a1a1a',
                                border: '1px solid #333',
                                borderRadius: '12px',
                                padding: '16px'
                            }}>
                                <Typography variant="h6" sx={{ color: '#d9ae03', fontWeight: 600, mb: 2 }}>
                                    Extend Due Date
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography sx={{ color: '#aaa', fontSize: 13 }}>
                                            Current Due Date
                                        </Typography>
                                        <Typography sx={{ color: '#fff', fontSize: 15, fontWeight: 600 }}>
                                            {pPlan?.paymentExpirationDate
                                                ? dayjs(pPlan.paymentExpirationDate).format('DD MMM YYYY')
                                                : 'N/A'
                                            }
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography sx={{ color: '#aaa', fontSize: 13 }}>
                                            New Due Date
                                        </Typography>
                                        <Typography sx={{ color: '#d9ae03', fontSize: 15, fontWeight: 600 }}>
                                            {extensionWeeks && parseInt(extensionWeeks) > 0
                                                ? dayjs(pPlan?.paymentExpirationDate).add(parseInt(extensionWeeks), 'week').format('DD MMM YYYY')
                                                : 'Select weeks above'
                                            }
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>

                        {/* Action Buttons */}
                        <Grid item xs={12}>
                            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 16 }}>
                                <Button
                                    size="large"
                                    variant="outlined"
                                    sx={{
                                        borderColor: '#555',
                                        color: '#fff',
                                        '&:hover': { borderColor: '#999', backgroundColor: 'rgba(255,255,255,0.05)' }
                                    }}
                                    onClick={() => setUnlockModalOpen(false)}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    size="large"
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#d9ae03',
                                        color: '#000',
                                        fontWeight: 600,
                                        '&:hover': { backgroundColor: '#e6c200' }
                                    }}
                                    onClick={handleConfirmUnlock}
                                    disabled={!extensionWeeks || parseInt(extensionWeeks) <= 0 || isLoading}
                                >
                                    {isLoading ? 'Unlocking...' : 'Unlock'}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>

        </div>
    );
}
